import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { PagesService } from 'src/app/pages/services/pages.service';
import { ManageMembersComponent } from './manage-members/manage-members.component';
import { ManageEmailService } from './service/manage-email.service';

@Component({
	selector: 'app-manage-email',
	templateUrl: './manage-email.page.html',
	styleUrls: ['./manage-email.page.scss'],
})
export class ManageEmailPage implements OnInit {
	currentPagePermission = 'company-manage-email';

	companyList$: Observable<any> = this.manageEmailService.getCompanyListState();
	showHeaderFilter = true;
	isCanOpenBox = true;
	constructor(
		private manageEmailService: ManageEmailService,
		public popoverController: PopoverController,
		public pagesService: PagesService,
	) {
		this.pagesService.notValidPermissionByName(
			this.currentPagePermission,
			'/app/company',
		);
		//
	}

	ngOnInit() {
		this.manageEmailService.loadCompanyListApi();
		this.manageEmailService.loadCompanyListData(0).subscribe();
	}

	handlePropertyChange({ name, value }: any) {
		if (name === 'searchPanel') {
			this.manageEmailService.loadCompanyListData(0, value).subscribe();
		}
	}

	async viewMails(members: any, companyId: any) {
		if (this.isCanOpenBox) {
			this.isCanOpenBox = false;
			const modal = await this.popoverController.create({
				component: ManageMembersComponent,
				componentProps: {
					members: members,
					companyId: companyId,
				},
			});

			modal.style.cssText = `--max-width: 540px;--min-width: 540px;`;

			await modal.present();

			await modal.onDidDismiss();

			this.isCanOpenBox = true;
		}
	}
}
